import { tv } from 'tailwind-variants';

export const chip = tv({
  base: 'font-notoSans flex gap-xs',
  variants: {
    size: {
      sm: 'w-fit h-fit px-2 py-1 text-xs',
      md: 'w-fit h-fit px-3 py-1 text-sm',
      lg: 'w-fit h-fit px-3 py-1 text-md',
    },
    variant: {
      filled:
        'bg-color-brand-primary text-mono-color-white border-hairline border-color-brand-primary',
      negative:
        'bg-mono-color-lighter text-mono-color-black border-hairline border-mono-color-lighter',
      outline:
        'text-mono-color-black border-color-brand-primary border-hairline',
      alterColor:
        'bg-color-transparent text-mono-color-black border-hairline hover:text-mono-color-white',
    },
    color: {
      'embriologia-superior': 'border-disciplina-embriologia-superior hover:bg-disciplina-embriologia-superior transition-colors duration-300',
      'farmacologia-superior': 'border-disciplina-farmacologia-superior hover:bg-disciplina-farmacologia-superior transition-colors duration-300',
      'fisiologia-superior': 'border-disciplina-fisiologia-humana-superior hover:bg-disciplina-fisiologia-humana-superior transition-colors duration-300',
      'genetica-superior': 'border-disciplina-genetica-superior hover:bg-disciplina-genetica-superior transition-colors duration-300',
      'anatomia-superior': 'border-disciplina-anatomia-humana-superior hover:bg-disciplina-anatomia-humana-superior transition-colors duration-300',
      'bioquimica-superior': 'border-disciplina-bioquimica-superior hover:bg-disciplina-bioquimica-superior transition-colors duration-300',
      'histologia-superior': 'border-disciplina-histologia-humana-superior hover:bg-disciplina-histologia-humana-superior transition-colors duration-300',
      'imunologia-superior': 'border-disciplina-imunologia-superior hover:bg-disciplina-imunologia-superior transition-colors duration-300',
      'parasitologia-superior': 'border-disciplina-parasitologia-superior hover:bg-disciplina-parasitologia-superior transition-colors duration-300',
      'patologia-superior': 'border-disciplina-patologia-superior hover:bg-disciplina-patologia-superior transition-colors duration-300',
      'microbiologia-superior': 'border-disciplina-microbiologia-superior hover:bg-disciplina-microbiologia-superior transition-colors duration-300',
    },
    radius: {
      pill: 'rounded-pill',
      sm: 'rounded-sm',
    },
    active: {
      false: '',
      true: '',
    },
  },
  compoundVariants: [
    {
      variant: 'filled',
      active: false,
      className: 'bg-mono-color-medium text-button-color-primary-disabled',
    },
    {
      variant: 'outline',
      active: false,
      className:
        'text-button-color-secondary-disabled text-button-color-secondary-disabled',
    },
    {
      color: 'embriologia-superior',
      active: true,
      className: 'bg-disciplina-embriologia-superior text-mono-color-white',
    },
    {
      color: 'farmacologia-superior',
      active: true,
      className: 'bg-disciplina-farmacologia-superior text-mono-color-white',
    },
    {
      color: 'fisiologia-superior',
      active: true,
      className: 'bg-disciplina-fisiologia-humana-superior text-mono-color-white',
    },
    {
      color: 'genetica-superior',
      active: true,
      className: 'bg-disciplina-genetica-superior text-mono-color-white',
    },
    {
      color: 'anatomia-superior',
      active: true,
      className: 'bg-disciplina-anatomia-humana-superior text-mono-color-white',
    },
    {
      color: 'bioquimica-superior',
      active: true,
      className: 'bg-disciplina-bioquimica-superior text-mono-color-white',
    },
    {
      color: 'histologia-superior',
      active: true,
      className: 'bg-disciplina-histologia-humana-superior text-mono-color-white',
    },
    {
      color: 'imunologia-superior',
      active: true,
      className: 'bg-disciplina-imunologia-superior text-mono-color-white',
    },
    {
      color: 'parasitologia-superior',
      active: true,
      className: 'bg-disciplina-parasitologia-superior text-mono-color-white',
    },
    {
      color: 'patologia-superior',
      active: true,
      className: 'bg-disciplina-patologia-superior text-mono-color-white',
    },
    {
      color: 'microbiologia-superior',
      active: true,
      className: 'bg-disciplina-microbiologia-superior text-mono-color-white',
    },
  ],
});

export const leftIconClasses = tv({
  base: 'cursor-pointer',
  variants: {
    size: {
      sm: 'text-xs',
      md: 'text-sm',
      lg: 'text-md',
    },
    variant: {
      filled: 'fill-current',
      negative: 'fill-current',
      outline: 'fill-current',
      alterColor: 'fill-current',
    },
  },
});

export const rightIconClasses = tv({
  base: 'cursor-pointer',
  variants: {
    size: {
      sm: 'text-xs',
      md: 'text-sm',
      lg: 'text-md',
    },
    variant: {
      filled: 'fill-current',
      negative: 'fill-current',
      outline: 'fill-current',
      alterColor: 'fill-current',
    },
  },
});
